import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { switchView } from './navigation.actions';
import { getActiveView } from './navigation.selectors';
import { UploaderView } from './uploader-view';

@Injectable({ providedIn: 'root' })
export class NavigationFacade {
  private readonly store = inject(Store);

  getActiveView(): Observable<UploaderView> {
    return this.store.select(getActiveView);
  }

  switchView(view: UploaderView): void {
    this.store.dispatch(switchView({ view }));
  }
}
